import { Box, IconButton, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import { EmailBody, UnassignedContentType } from "../../../types/files";
import theme from "../../../theme";
import LaunchIcon from '@mui/icons-material/Launch';
import { scrollbarStyle } from "../../../shared/dashboard";

const useStyles = makeStyles((theme) => ({
    summaryContainer: {
        width: '100%',
        height: 'auto',
        background: '#fff',
        border: `1px solid ${theme.colors.neutral['300']}`,
        boxShadow: '0px 4px 10px -1px rgba(16, 24, 40, 0.06)',
        borderRadius: 16,
        padding: 16,
        breakInside: 'avoid',
        transition: '0.05s ease-in-out',
    },
    noteBlock: {
        width: '100%',
        height: 'auto',
        minHeight: '67px',
        maxHeight: '112px',
        overflowY: 'auto',
        ...scrollbarStyle,
    },
    noteText: {
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        color: theme.colors.neutral['600'],
        textAlign: 'left',
    },
    icon: {
        width: 24,
        height: 24,
    },
    textField: {
      width: '100%',
      height: '100%',
      padding: '12px',
      border: '1px solid darkgray',
      borderRadius: 8,
      background: 'transparent',
      overflowY: 'auto',
      "&:active": {
        borderColor: 'darkgreen !important',
      },
      ...scrollbarStyle,
    },
    sender: {
      fontFamily: 'Inter',
      fontSize: '0.95rem',
      fontWeight: 'bold',
      color: `${theme.colors.neutral['700']} !important`,
    },
    timestamp: {
      fontFamily: 'Lato',
      fontSize: '0.85rem',
      color: `${theme.colors.neutral['500']} !important`,
    },
    message: {
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: '400',
      color: `${theme.colors.neutral['600']} !important`,
      wordBreak: 'break-word',
      whiteSpace: 'pre-line',
      textAlign: 'left',
    },
}));

const ContentSummaryAnswer: React.FC<{
    content: EmailBody & {summary?: string, threads?: ({ timestamp: string|null, sender?: string, message: string })[]},
    onViewEmail?: (content: EmailBody & {summary : string}) => void,
 }> = ({ content, onViewEmail }) => {
    const classes = useStyles();

    return (<>
        <Stack direction="row" className={classes.summaryContainer}
            alignItems="flex-start" justifyContent="space-between">
            <Box className={classes.noteBlock}>
                {content?.type === UnassignedContentType.LINKEDIN_MESSAGE ? (
                    <Stack alignItems="stretch" justifyContent="flex-start">
                        {content?.threads?.map((thread, i) => (
                            <Stack alignItems="flex-start" justifyContent="flex-start" width="100%"
                                key={'linkedin-messages-125-' + i}>
                                {!!thread.sender && (
                                    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                                        <Typography className={classes.sender} mt={1}>
                                            {`${thread.sender}`}
                                        </Typography>
                                        {/* {!!thread.timestamp && (
                                            <Typography className={classes.timestamp}>
                                                {moment(`${thread.timestamp}`).format('MMM D, Y HH:mm')}
                                            </Typography>
                                        )} */}
                                    </Stack>
                                )}
                                <Typography className={classes.message}>
                                    {`${thread.message}`}
                                </Typography>
                            </Stack>
                        ))}
                    </Stack>
                ) : (
                    <Typography className={classes.noteText}>
                        {content?.summary || 'No email summary'}
                    </Typography>
                )}
            </Box>
            {!!onViewEmail && (content?.type !== UnassignedContentType.LINKEDIN_MESSAGE) && (
                <IconButton disableRipple
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onViewEmail?.(content as EmailBody & { summary: string });
                    }}
                    sx={{ padding: 'unset !important'}}>
                    <LaunchIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                </IconButton>
            )}
        </Stack>
    </>);
}

export default ContentSummaryAnswer;
